'use strict';
/*!
* viewport.js
*/

var ViewPort = function(){
	this.breakpoint = 1024;
	this.$viewport = document.querySelector('meta[name="viewport"]');
	this.ua = window.navigator.userAgent;
	this.isSP = ( this.ua.indexOf('iPhone') != -1 || this.ua.indexOf('iPod') != -1 || this.ua.indexOf('iPad') != -1 || this.ua.indexOf('Android') != -1 )? true : false;
	this.isAndroidDefault = ( this.ua.indexOf('Android') != -1 && this.ua.indexOf('Chrome') == -1 )? true : false;
	this.change = function(){
		if( !this.isSP ) return false;
		this.screenW = ( this.isAndroidDefault )? screen.width/window.devicePixelRatio : screen.width;
		this.screenH = ( this.isAndroidDefault )? screen.height/window.devicePixelRatio : screen.height;
		this.width = ( window.orientation != 90 && window.orientation != -90 )? this.screenW : this.screenH;
		if( this.width > this.breakpoint ) {
			this.$viewport.content = 'width=1280';
		} else {
			this.$viewport.content = 'width=device-width,initial-scale=1.0,user-scalable=no';
		}
	};
};
var viewport = new ViewPort();
viewport.change();
window.onorientationchange = function(){
	viewport.change();
};